import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import InvoiceRejectionForm from '../InvoiceRejectionForm';
import BulkActionButton from '../../../../common/utils/Workqueue/BulkActionButton';

export const InvoiceRejectionModal = ({
  icon,
  invoice,
  onSuccess,
  disableInvoiceRejectionModal,
}) => {
  const iwqBulkRejectionFormRef = useRef();

  const openRejectionModal = () => {
    iwqBulkRejectionFormRef.current.openDialog();
  };

  const closeRejectionModal = () => {
    iwqBulkRejectionFormRef.current.closeDialog();
  };
  return (
    <div>
      <BulkActionButton
        action="Reject"
        onClick={openRejectionModal}
        icon={icon}
        disabled={disableInvoiceRejectionModal}
      />
      <InvoiceRejectionForm
        invoice={invoice}
        isNetworkLead={false}
        isPayerProvider
        close={closeRejectionModal}
        setRef={iwqBulkRejectionFormRef}
        onSuccess={onSuccess}
      />
    </div>
  );
};

InvoiceRejectionModal.propTypes = {
  invoice: PropTypes.object,
  icon: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired,
  disableInvoiceRejectionModal: PropTypes.bool.isRequired,
};

InvoiceRejectionModal.defaultProps = {
  invoice: {},
};
